import ContactUsPage from '@/modules/contact-us/contact-us-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/contact-us/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ContactUsPage />;
}
